import React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";

import { IOperationData, TranslationKeyType, IInfoPageOperation } from "../../../constants/types";
import InfoReportFlow from "./InfoReportFlow";

import './InfoPageOperation.scss'

interface Props extends WithTranslation{
    operation: IInfoPageOperation,
    data: IOperationData,
    onChange: (changes: IOperationData) => void
};

//minimum length in order to "OK" operation
const minInputLength = 3;

class InfoPageOperation extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    componentDidMount(): void {
        if(this.props.data.OK === false) {
            this.props.onChange({OK: true, discarded: false});
        }
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any): void {
        if(this.props.data.OK === false) {
            this.props.onChange({OK: true, discarded: false});
        }
    }

    render() {
        const { t, operation } = this.props;
        
        return <div className="render-info-page-operation">
            <h4>{t(operation.header as unknown as TemplateStringsArray)}</h4>
            {operation.information.map(s => <div className="ip-info">{t(s as unknown as TemplateStringsArray)}</div>)}
            <InfoReportFlow />
        </div>;
    }
};

export default withTranslation()(InfoPageOperation);